import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=c59a8dd0&scoped=true&"
import script from "./ContentPage.vue?vue&type=script&lang=ts&"
export * from "./ContentPage.vue?vue&type=script&lang=ts&"
import style0 from "./ContentPage.vue?vue&type=style&index=0&id=c59a8dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59a8dd0",
  null
  
)

export default component.exports